import styled, { css, FlattenSimpleInterpolation } from 'styled-components';

export const StyledMachineOperatingHoursDashboardChart = styled.div`
  ${({ theme: { kcc } }): FlattenSimpleInterpolation => css`
    flex: 1;
    height: 100%;
    display: flex;
    flex-direction: column;
    background-color: ${kcc.colors.WHITE};
    border: ${kcc.lineWidth.BORDER}px solid ${kcc.colors.GRAY_100};
    padding: ${kcc.spacing.LG};
    font-family: ${kcc.typography.FONT_FAMILY};
    color: ${kcc.colors.TEXT};
    gap: ${kcc.spacing.BASE};

    .machine-operating-hours-dashboard-chart__title-bar {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;

      .machine-operating-hours-dashboard-chart__info-icon {
        display: inline-flex;
        flex-shrink: 0;
        width: 24px;
        height: 24px;
      }
    }

    .machine-operating-hours-dashboard-chart__title {
      font-size: ${kcc.typography.FONT_SIZE.HEADING_4}px;
      font-weight: ${kcc.typography.FONT_WEIGHT.EXTRA_BOLD};
      line-height: 24px;
      text-transform: capitalize;
      margin: 0;
    }

    .machine-operating-hours-dashboard-chart__elements {
      display: grid;
      grid-template-columns: max-content minmax(0, 1fr) max-content;
      column-gap: ${kcc.spacing.XS};
      row-gap: 8px;
      align-items: center;
      width: 100%;
    }

    .machine-operating-hours-dashboard-chart__element {
      display: contents;
    }

    .ant-skeleton-paragraph {
      li:first-child {
        margin-block-start: 0 !important;
      }

      li {
        width: 100% !important;
        margin-block-start: 18px !important;
      }
    }
  `}
`;
